import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, Mail, Heart } from 'lucide-react';
import { BRAND } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Collections', path: '/collections' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const collections = [
    { name: 'Pet Anime', path: '/collections/pet-anime' },
    { name: 'Couple Anime', path: '/collections/couple-anime' },
    { name: 'Corporate Custom', path: '/collections/corporate-custom' },
    { name: 'Self Custom', path: '/collections/self-custom' },
  ];

  const legal = [
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Terms & Conditions', path: '/terms-conditions' },
    { name: 'Refund Policy', path: '/refund-policy' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center mb-6">
              <img src="/images/logo_transparent.png" alt="AuraPrintiqo" className="h-14 w-auto object-contain" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Transform your cherished photos into stunning anime-style artwork,
              printed on premium quality apparel. Made with love, delivered to your door.
            </p>
            <div className="flex gap-3">
              <a href={BRAND.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[hsl(350,70%,65%)] transition-colors duration-300">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={BRAND.whatsapp} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-green-500 transition-colors duration-300">
                <MessageCircle className="w-5 h-5" />
              </a>
              <a href={`mailto:${BRAND.email}`} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[hsl(20,90%,70%)] transition-colors duration-300">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-6">Collections</h4>
            <ul className="space-y-3">
              {collections.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-6">Legal</h4>
            <ul className="space-y-3">
              {legal.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-400 hover:text-white transition-colors duration-300 text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <h4 className="text-lg font-semibold mb-4">Get in Touch</h4>
              <a href={`mailto:${BRAND.email}`} className="text-gray-400 hover:text-white transition-colors text-sm">
                {BRAND.email}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm text-center sm:text-left">
              © {currentYear} {BRAND.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {legal.map((link) => (
                <Link key={link.path} to={link.path} className="text-gray-500 hover:text-gray-300 text-xs transition-colors">
                  {link.name}
                </Link>
              ))}
            </div>
            <p className="text-gray-400 text-sm flex items-center gap-1">
              Made with <Heart className="w-4 h-4 text-[hsl(350,70%,65%)] fill-current" /> in India
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
